<template>
  <div>
    <portal to="page-top-title">Edit Sender #{{ id }}</portal>
    <portal to="page-top-right">
      <btn :route="{ name: 'senders-single', params: { id: id } }" icon="fa-eye" text>Back to Sender</btn>
    </portal>

    <box-form action="edit" data-prop="formData" redirect="senders-list" :url="`/senders/${id}`" :loaded="loaded" loader>
      <template slot="content">
        <row>
          <column-input>
            <form-group-input name="name" :model="formData.name" :min="3" :max="64" :disabled="!editable.name" required/>
          </column-input>
          <column-input>
            <form-group-select name="category_id" title="Category" :model="formData.category_id"
                               :options="categories" :disabled="!categories.length" required/>
          </column-input>
          <column-input :md="2">
            <form-group-check name="active" :model="formData.active"/>
          </column-input>
        </row>
      </template>
    </box-form>
  </div>
</template>

<script>
import BoxForm from '@/views/components/data/BoxForm'
import Btn from '@/views/components/simple/Btn'
import FormGroupCheck from '@/views/components/form/FormGroupCheck'
import FormGroupInput from '@/views/components/form/FormGroupInput'
import FormGroupSelect from '@/views/components/form/FormGroupSelect'
import Form from '@/modules/utils/Form'

export default {
  name: 'SendersEdit',
  metaInfo () {
    return { title: `Sender #${this.id} | Edit` }
  },
  components: {
    BoxForm,
    Btn,
    FormGroupCheck,
    FormGroupInput,
    FormGroupSelect
  },
  computed: {
    id () { return this.$route.params.id }
  },
  data () {
    return {
      loaded: false,
      categories: [],
      editable: {},
      formData: {
        name: Form.types.input(),
        active: Form.types.boolean(),
        category_id: Form.types.select()
      }
    }
  },
  created () {
    this.loadEntity()
    this.loadCategories()
  },
  methods: {
    loadEntity () {
      this.$http
        .get(`/senders/${this.id}`)
        .then((res) => {
          const { data: { data } } = res

          this.formData.name.value = data.name
          this.formData.active.value = data.active
          this.formData.category_id.value = { id: data.category.id, name: data.category.name }
          this.editable = data.metadata.editable

          this.loaded = true
        })
    },
    loadCategories () {
      this.$http
        .get('/senders/categories', { params: { no_pages: 1 } })
        .then((res) => {
          const { data: { data } } = res

          this.categories = data.map((category) => { return { id: category.id, name: category.name } })
        })
    }
  }
}
</script>
